export default "__VITE_ASSET__D_SNVkCM__"